<template>
  <div class="container_cm">
    <div class="main_cm">
      <div class="bh_cm">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/guidance' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>规范库管理</el-breadcrumb-item>
          <el-breadcrumb-item>规范库</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="top_cm">
        <div>
          <span>规范名称</span>
          <el-input v-model="searchForm.standardName" maxlength="100"  clearable placeholder="请输入规范名称"></el-input>
          <span>编号</span>
          <el-input v-model="searchForm.standardCode" maxlength="100"  clearable placeholder="请选择编号"></el-input>
          <span>版本号</span>
          <el-input v-model="searchForm.version" maxlength="100"  clearable placeholder="请输入版本号"></el-input>
        </div>
        <div>
          <el-button class="mybtny" v-waves icon="el-icon-search" @click="toSearch">搜索</el-button>
          <el-button class="mybtny" v-waves icon="el-icon-refresh-right" @click="reset">重置</el-button>
          <el-button class="mybtny" v-waves icon="el-icon-edit" @click="addProject">新增</el-button>
        </div>
      </div>
      <div class="table_cm">
        <Table ref="multipleTable" v-loading="loading" :tableData="List" :pageSize='pageSize' :currentPage="pageIndex" :cloumns="cloumns" :totalNum="total" :pageFlag='true' :selection='false' @handleCurrentChange="handleCurrentChange">
          <el-table-column prop="standardName" label="规范名称" align="center">
          </el-table-column>
          <el-table-column prop="standardCode" label="编号" align="center" sortable>
          </el-table-column>
          <el-table-column prop="version" label="最新版本" align="center" sortable>
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人" align="center" sortable>
          </el-table-column>
          <el-table-column prop="updateTime" label="更新日期" align="center" sortable>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="editClick(scope.row)">编辑</el-button>
              <!-- <el-button type="text" @click.native.prevent="download(scope.row)">下载</el-button> -->
              <el-button type="text" @click.native.prevent="stop(scope.row)">删除</el-button>
              <el-button type="text" @click.native.prevent="versionmana(scope.row)">版本管理</el-button>
            </template>
          </el-table-column>
        </Table>
      </div>
    </div>
    <!-- 新增规范库 -->
    <div>
      <el-dialog title="新增规范库" center :visible.sync="addVisible" width="700px" v-if="addVisible" :close-on-click-modal="false">
        <addProject @cancel="cancel" @submit="submit"></addProject>
      </el-dialog>
    </div>
    <!-- 编辑规范库 -->
    <div>
      <el-dialog title="编辑规范库" center :visible.sync="editVisible" width="700px" v-if="editVisible" :close-on-click-modal="false">
        <editProject @cancel="cancelEdit" @submit="submit" :editData='editData'></editProject>
      </el-dialog>
    </div>
    <!-- 版本管理 -->
    <div>
      <el-dialog title="" center :visible.sync="versionListVisible" width="1600px" v-if="versionListVisible">
        <versionList :versionList="versionList"></versionList>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  GetList,
  addCompany,
  updateCompany,
  delCompany,
} from "@/api/Standard.js";
import { FileUrl } from "@/api/depotApi";
import addProject from "./components/addProject";
import editProject from "./components/editProject";
import Table from "@/components/myTable";
import versionList from "./components/versionList";
export default {
  inject: ["reload"],
  components: {
    addProject,
    editProject,
    Table,
    versionList,
  },
  data() {
    return {
      userInfo: "",
      List: [],
      cloumns: [],
      loading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      searchForm: {},
      addVisible: false, //新增项目弹窗
      editVisible: false, //编辑项目弹窗
      editData: "", //待编辑项目数据
      versionListVisible: false,
      versionList: {},
    };
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
  },
  mounted() {
    this.getStandardList();
  },
  methods: {
    getStandardList() {
      let params = {
        deptId: this.userInfo.deptId,
        current: this.pageIndex,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.loading = true;
      GetList(params)
        .then((res) => {
          if (res.code == "200") {
            this.List = res.data.records;
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg || "服务器连接失败");
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.msg || err.message || "服务器连接失败");
        });
    },
    toSearch() {
      this.pageIndex = 1;
      this.getStandardList();
    },
    reset() {
      this.pageIndex = 1;
      this.searchForm = {};
      this.getStandardList();
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getStandardList();
    },
    // 刷新
    refresh() {
      this.reload();
    },
    // 新增项目
    addProject() {
      this.addVisible = true;
    },
    // 编辑项目
    editClick(row) {
      let { standardCode, standardName, version, fileName, filePath, id } = row;
      this.editData = {
        standardCode,
        standardName,
        version,
        fileName,
        filePath,
        id,
      };
      this.editVisible = true;
    },
    // 新增/编辑项目提交
    submit(data, isAdd) {
      if (isAdd) {
        let params = {
          deptId: Number(this.userInfo.deptId),
          createUser: Number(this.userInfo.userId),
          ...data,
        };
        addCompany(params).then((res) => {
          if (res.code == "200") {
            this.$message.success(res.msg || "新增成功！");
            this.cancel();
            this.getStandardList();
          } else {
            this.$message.error(res.msg || "新增失败！");
          }
        });
      } else {
        updateCompany({ ...data }).then((res) => {
          if (res.code == "200") {
            this.$message.success(res.msg || "修改成功！");
            this.cancelEdit();
            this.getStandardList();
          } else {
            this.$message.error(res.msg || "修改失败！");
          }
        });
      }
    },
    // 新增取消
    cancel() {
      this.addVisible = false;
    },
    // 编辑取消
    cancelEdit() {
      this.editVisible = false;
    },
    // 停用
    stop(row) {
      this.$confirm("确定删除该规范吗?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCompany(row.id).then((res) => {
            if (res.code == "200") {
              this.$message.success(res.msg || "删除成功！");
              this.getStandardList();
            } else {
              this.$message.error(res.msg || "删除失败！");
              this.getStandardList();
            }
          });
        })
        .catch(() => {});
    },
    download(row) {
      FileUrl({ url: row.filePath }).then((res) => {
        var index = row.filePath.lastIndexOf(".");
        //获取后缀
        var ext = row.filePath.substr(index + 1);
        this.mixin.fileLinkToStreamDownload(res.data, row.fileName, ext);
      });
    },
    versionmana(row) {
      let { versionLst, id } = row;
      this.versionList = {
        versionLst,
        id,
      };
      this.versionListVisible = true;
    },
    cancelVersionList() {
      this.versionListVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.container_cm {
  width: 100%;
  height: calc(100% - 30px);
  padding: 15px 0;
  .main_cm {
    height: calc(100% - 82px);
    margin: 0 auto;
    .bh_cm {
      height: 20px;
      line-height: 20px;
    }
    .top_cm {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 200px;
        margin: 0 20px;
      }
      .el-button {
        width: 140px;
        margin-left: 20px;
      }
      .el-select {
        margin: 0 20px;
      }
    }
    .table_cm {
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/StandardMana/index.vue